import $ from 'jquery';
import {util} from '../lib/util';

import '../lib/slidescroll.js';

$(document).ready(() => {


  function loadReferralForm(email, first_name, headline = "Give $20, get $20.<br />Now that's a win-win.") {
    if (email && util.validEmail(email)) {
      $('#email-form').hide();
      $('#referralcandy-container').html(`<iframe id="refcandy-candyjar" data-id="${themeConfiguration.referralCandyCampaignId}" data-height="400" data-width="100%" data-email="${email}" data-fname="${first_name}" title="Your unique referral link" frameborder=0></iframe><script>!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0];if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src="//portal.referralcandy.com/assets/widgets/refcandy-candyjar.js";fjs.parentNode.insertBefore(js,fjs);}}(document,"script","refcandy-candyjar-js");</script>`);
      $('#refer-headline').html(headline);
      $('#refer-content').hide();
    }
  }

  let email = util.getUrlParam('email', '').replace('%40', '@');
  let first_name = util.getUrlParam('first-name', '');

  if (email) {
    loadReferralForm(email, first_name);
  }

  $('button#referral-submit').click((evt) => {

    evt.preventDefault();

    util.buttonToProcessingState($('button#referral-submit'), 'Processing...');

    $('.email-error').slideUp();

    setTimeout(() => {

      if (util.validEmail($('#email-field').val()) === null) {
        $('.email-error').slideDown();
        util.buttonToNormalState($('button#referral-submit'), 'Claim My Code');
        return;
      } else {
        $('.email-error').slideUp();
      }

      email = $('#email-field').val();
      first_name = $('#first-name-field').val();

      loadReferralForm(email, first_name, "Here's your unique link!");

    }, 1000);

  });

});
